import React, { Children, forwardRef } from 'react';
import Spinner from './Spinner';
import { Button, PressEvent } from 'react-aria-components';

interface ILoadingButton {
  isLoading: boolean,
  buttonText: string
  loadingText?: string | undefined,
  className?: string | undefined,
  onPress: (e: PressEvent) => any,
  isDisabled: boolean,
  children?: any | undefined,
  spinnerColour?: string
}

const LoadingButton = forwardRef<HTMLButtonElement, ILoadingButton>(({ isLoading, buttonText, loadingText, children, spinnerColour, ...props }, ref) => {
  return (
    <Button ref={ref} type="button" {...props}>
      {isLoading ? (
        <div className="spinner__wrapper">
          <Spinner colour={spinnerColour} />
          {loadingText && <p className="button-text">{loadingText}</p>}
        </div>
      ) : (
        <>
        {children}
        <p className="button-text">{buttonText}</p>
        </>
      )}
    </Button>
  );
});

export default LoadingButton;
